export const DUPLICATE_APPS_GET_EXISTING_APPLICATION_COMPARISON_LOADING =
  'DUPLICATE_APPS_GET_EXISTING_APPLICATION_COMPARISON_LOADING';
export const DUPLICATE_APPS_GET_EXISTING_APPLICATION_COMPARISON_SUCCESS =
  'DUPLICATE_APPS_GET_EXISTING_APPLICATION_COMPARISON_SUCCESS';
export const DUPLICATE_APPS_GET_EXISTING_APPLICATION_COMPARISON_ERROR =
  'DUPLICATE_APPS_GET_EXISTING_APPLICATION_COMPARISON_ERROR';
export const DUPLICATE_APPS_CLEAR_ERRORS = 'DUPLICATE_APPS_CLEAR_ERRORS';
export const DUPLICATE_APPS_START_NEW_APPLICATION =
  'DUPLICATE_APPS_START_NEW_APPLICATION';
export const DUPLICATE_APPS_EDIT_APPLICATION =
  'DUPLICATE_APPS_EDIT_APPLICATION';
export const DUPLICATE_APPS_GET_DUPLICATE_APPS_LOADING =
  'DUPLICATE_APPS_GET_DUPLICATE_APPS_LOADING';
export const DUPLICATE_APPS_GET_DUPLICATE_APPS_SUCCESS =
  'DUPLICATE_APPS_GET_DUPLICATE_APPS_SUCCESS';
export const DUPLICATE_APPS_GET_DUPLICATE_APPS_ERROR =
  'DUPLICATE_APPS_GET_DUPLICATE_APPS_ERROR';



// WEBPACK FOOTER //
// ./src/pages/reviewincomingapplications/state/duplicateapps/types.js